import { StyleSpecification } from "@iventis/mapbox-gl";
import { BasemapDataStore } from "./basemap-data-store";

export type Sitemap2d = StyleSpecification & { expiry: string };

export class Sitemap2dDataStore extends BasemapDataStore<Sitemap2d> {
    private addSitemapSignature(url: string, signature: string, assetVersion: string): string {
        const querySeparator = url.includes("?") ? "&" : "?";
        return `${url}${querySeparator}${signature}&assetVersion=${assetVersion}`;
    }

    protected async getBasemapApiCall(sitemapId: string): Promise<Sitemap2d> {
        const sitemapAsset = await this.getBasemapAsset(sitemapId);
        const sitemapRequest = await fetch(sitemapAsset.url);
        const sitemapJson = (await sitemapRequest.json()) as Sitemap2d;
        const assetVersion = sitemapAsset.updatedAt?.toISOString() ?? "";
        const signature = sitemapAsset.signature ?? "";

        for (const source of Object.values(sitemapJson.sources ?? {})) {
            if (source.type === "vector" || source.type === "raster") {
                if (source.tiles != null) {
                    source.tiles = source.tiles.map((tile) => this.addSitemapSignature(tile, signature, assetVersion));
                }

                if (source.url != null) {
                    source.url = this.addSitemapSignature(source.url, signature, assetVersion);
                }
            }
        }

        return { ...sitemapJson, expiry: sitemapAsset.expiry };
    }
}
